import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AppFilter, User } from '@app/shared/models';
import {
  ComponentModalConfig,
  ModalSize,
  SuiModal,
} from '@richardlt/ng2-semantic-ui';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { WorkFlowService } from '../../services/workflow.service';

interface ICreateWorkflowGroupContext {
  title?: string;
  extraData?: any;
  isEdit?: boolean;
}

@Component({
  selector: 'app-add-new-workflow',
  templateUrl: './add-new-workflow-group.component.html',
  styleUrls: ['./add-new-workflow-group.component.scss'],
})
export class AddNewWorkflowGroupComponent implements OnInit {
  filter: AppFilter;
  success: any;
  error: any;
  pending: boolean = false;
  workflow: any;
  allUsers: any;
  formSubmitAttempt;
  groupUser: Array<string> = [];
  selectedUsers = [];
  searchable = true;
  groupId;
  search = new FormControl('');
  workGroupFormGroup: FormGroup = this.fb.group({
    name: ['', Validators.required],
    description: ['', Validators.required],
    appUserIds: [''],
  });
  organizationId: any =
    localStorage.getItem('userData') != null
      ? JSON.parse(localStorage.getItem('userData')).appUser.organization
          .organizationId
      : '';

  // searchFilter = {
  //   groupOp: 'AND',
  //   rules: [
  //     {
  //       field: 'organizationId.organizationTypeId.organizationTypeId',
  //       op: 'ne',
  //       data: 'contractor',
  //     },
  //   ],
  // };

  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  nextPage(value) {
    this.filter.page = value;
    this.getUsers('');
  }
  constructor(
    public modal: SuiModal<ICreateWorkflowGroupContext, any, any>,
    private workflowService: WorkFlowService,
    private fb: FormBuilder
  ) {
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10,
      sord: 'desc',
    });
    this.getUsers('');

    this.search.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchText) => {
        console.log(searchText);
        this.searchUser(searchText);
      });
  }

  getUsers(search) {
    this.pending = true;

    if (search !== '') {
      this.filter.filters = JSON.stringify(search);
    }
    this.workflowService
      .getAllUsers2({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.allUsers = res['rows'] as Array<User>;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.currentPage = this.filter.page;
          this.allUsers.forEach((u) => {
            if (u['firstName'] === null) {
              u['firstName'] = u['appUserEmail'];
            }
            if (u['lastName'] === null) {
              u['lastName'] = '';
            }
            u.name = `${u['firstName']} ${u['lastName']}`;
          });
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getOrganizationUsers(data) {
    this.pending = true;
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 1000,
      sord: 'desc',
    });
    this.filter.filters = JSON.stringify(data);
    this.workflowService
      .getAllAppUsersInOrganization({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.allUsers = res['rows'] as Array<User>;
          this.allUsers.forEach((u) => {
            if (u['firstName'] === null) {
              u['firstName'] = u['appUserEmail'];
            }
            if (u['lastName'] === null) {
              u['lastName'] = '';
            }
            u.name = `${u['firstName']} ${u['lastName']}`;
          });
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  searchUser(search) {
    if (search === '') {
      this.filter = new AppFilter({ sidx: 'dateCreated' });
      // this.filter.filters = JSON.stringify(searchFilter);
      this.getUsers('');
    } else {
      let searchFilter = {
        groupOp: 'OR',
        rules: [
          {
            field: 'appUserEmail',
            op: 'cn',
            data: '',
          },
          {
            field: 'lastName',
            op: 'cn',
            data: '',
          },
          {
            field: 'firstName',
            op: 'cn',
            data: '',
          },
        ],
      };
      searchFilter.rules[0].data = search;
      searchFilter.rules[1].data = search;
      searchFilter.rules[2].data = search;
      this.filter.filters = JSON.stringify(searchFilter);
      this.getUsers(searchFilter);
    }
  }

  checkChange(id, event) {
    if (event.target.checked) {
      this.selectedUsers.push(id);
    } else {
      this.selectedUsers.forEach((u) => {
        if (u == id) {
          this.selectedUsers.splice(this.selectedUsers.indexOf(id), 1);
        }
      });
    }
  }

  isFieldValid(field: string) {
    return (
      (!this.workGroupFormGroup.get(field).valid &&
        this.workGroupFormGroup.get(field).touched) ||
      (this.workGroupFormGroup.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  isChecked(id) {
    if (this.selectedUsers.filter((i) => i == id).length > 0) {
      return true;
    } else {
      return false;
    }
  }

  close() {
    this.success = null;
    this.error = null;
  }

  ngOnInit(): void {
    if (this.modal.context.isEdit) {
      this.groupId = this.modal.context.extraData['workflowGroupId'];
      this.workGroupFormGroup.patchValue({
        name: this.modal.context.extraData.name,
        description: this.modal.context.extraData.description,
        appUserIds: this.modal.context.extraData.appUserIds,
      });
      this.selectedUsers = this.modal.context.extraData.appUserIds;
    }
  }

  save() {
    if (this.workGroupFormGroup.valid) {
      this.workGroupFormGroup.value['appUserIds'] = this.selectedUsers;
      this.modal.approve(this.workGroupFormGroup.value);
    } else {
      this.error = 'Please fill all required fields';
    }
  }
}

export class AddNewWorkflowGroupModal extends ComponentModalConfig<
  ICreateWorkflowGroupContext,
  void,
  void
> {
  constructor(
    title: string,
    extraData?: any,
    isEdit?: boolean,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(AddNewWorkflowGroupComponent, {
      title,
      extraData,
      isEdit,
    });
    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
